import { createAsyncThunk } from '@reduxjs/toolkit';
import { handleError, handleResponse, MyAxios } from '@services/SettingAxios';
import { DeliveryDescription } from '../types/deliverySchema';
import { RegionQueryDto } from './api.dto';

export const getDeliveryDescription = createAsyncThunk<DeliveryDescription[], RegionQueryDto>(
  'delivery/getDeliveryDescription',
  async query => {
    return await MyAxios.get(`/api/order/get-how-to-buy?regionId=${query.regionId}`).then(handleResponse).catch(handleError);
  },
);
